module.exports = __webpack_public_path__ + "media/images/sp/specials/fair/title_deco-ad048b75b824d83906c5fc9cddce3ab2.svg";